import React, { useState } from "react";
import { InputType } from "../../Utils/Utils";
import { SvgImages } from "../../Utils/LocalImages";
import Image from "./Image";

function CustomTextArea({
  name,
  register,
  labelTitle,
  placeholder,
  inputType,
  additionalClasses,
  showError,
  errorMessage,
  showMandatory = false,
  rows,
  ...props
}) {
  const [useType, setUseType] = useState(inputType);
  const [focus, setFocus] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleInputFocus = () => {
    setFocus(true);
  };

  const handleInputBlur = () => {
    setFocus(false);
  };

  const handleInputChange = (event) => {
    setCharCount(event.target.value.length);
  };

  const handleTextAreaBlur = (e) => {
    handleInputBlur();
    if (register) register(name).onBlur(e); // Propagate blur to react-hook-form
  };

  return (
    <div className="form-group d-flex flex-column">
      <label className="fw-600 medium-text">
        {labelTitle}{showMandatory ? <span className="danger">*</span> : null}
      </label>
      <div className="d-flex flex-column">
        <textarea
          type={useType}
          className={`w-100 medium-text fw-400 custom-form-input ${additionalClasses ? additionalClasses : ""} ${inputType === InputType.password ? "pe-5" : ""}`}
          placeholder={placeholder}
          maxLength={300} // Set maximum character limit
          rows={rows}
          onChange={(e) => {
            handleInputChange(e);
            if (register) register(name).onChange(e); // Propagate change to react-hook-form
          }}
          onFocus={handleInputFocus}
          onBlur={handleTextAreaBlur}
          {...props}
          {...(register ? register(name) : {})} // Register only if provided
        />
       
        {inputType === InputType.password ? (
          <Image
            className=" cursor-pointer"
            src={useType !== InputType.password ? SvgImages.password_show : SvgImages.password_hide}
            onClick={() => {
              setUseType(useType === InputType.password ? InputType.text : InputType.password);
            }}
          />
        ) : null}
      </div>
      <div className={focus ? "form-input-bottom-line-focused" : "form-input-bottom-line"} />
      {showError ? <span className="danger small-text fw-400 mt-2">{errorMessage}</span>
       : null}
       {/* <span className="small-text fw-400 mt-2">
        {300 - charCount} characters remaining
      </span> */}
    </div>
  );
}

export default CustomTextArea;
